import './style/index.less';
import TurnstileDialog from './TurnstileDialog';

export default TurnstileDialog;
